var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"text-blue-500 underline",attrs:{"to":{ name: 'Orders', params: { orderNumber: this.params.value }},"target":_vm.target}},[_vm._v(" "+_vm._s(_vm.params.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }